/*
 * MICU baby - Wishlist (favoritos) con localStorage. Vanilla, sin dependencias.
 *
 * Contrato del tema:
 *   - Boton corazon:  [data-wishlist-toggle][data-handle]  -> alterna .is-active + aria-pressed
 *   - Badge del header: [data-wishlist-count]              -> numero + mostrar/ocultar
 *   - Pagina favoritos: [data-wishlist-grid] (grid vacio) + [data-wishlist-empty]
 *
 * Almacenamiento: clave "micu_wishlist" = array de handles de producto.
 * La pagina de favoritos reconstruye las tarjetas obteniendo cada producto
 * por handle via el endpoint nativo /products/<handle>.js
 */
(function () {
  'use strict';

  var KEY = 'micu_wishlist';

  function read() {
    try {
      var arr = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(arr)) return [];
      return arr.filter(function (h) { return typeof h === 'string' && h.length > 0; });
    } catch (e) {
      return [];
    }
  }

  function write(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {}
  }

  function toggle(handle) {
    var arr = read();
    var i = arr.indexOf(handle);
    if (i === -1) arr.push(handle); else arr.splice(i, 1);
    write(arr);
    return i === -1;
  }

  function syncButtons() {
    var saved = read();
    var btns = document.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      var active = saved.indexOf(b.getAttribute('data-handle')) !== -1;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
    }
  }

  function syncCount() {
    var n = read().length;
    var els = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = n;
      els[i].style.display = n > 0 ? '' : 'none';
    }
  }

  function formatMoney(cents) {
    var amount = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(amount);
    } catch (e) {
      return amount.toFixed(2).replace('.', ',') + ' €';
    }
  }

  function esc(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function sizedImage(url, width) {
    if (!url) return '';
    var u = String(url);
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function buildCell(p) {
    var cell = document.createElement('div');
    cell.className = 'wlp-cell';
    var url = p.url || ('/products/' + p.handle);
    var img = sizedImage(p.featured_image, 400);
    var onSale = p.compare_at_price && p.compare_at_price > p.price;
    cell.innerHTML =
      '<a href="' + esc(url) + '" class="wlp-link">' +
        '<div class="wlp-media">' +
          (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" width="400" height="533">' : '') +
        '</div>' +
        '<div class="wlp-title">' + esc(p.title) + '</div>' +
        '<div class="wlp-price">' + formatMoney(p.price) +
          (onSale ? '<span class="wlp-compare">' + formatMoney(p.compare_at_price) + '</span>' : '') +
        '</div>' +
      '</a>' +
      '<button type="button" class="wlp-remove" data-wishlist-toggle data-handle="' + esc(p.handle) + '">Quitar</button>';
    return cell;
  }

  function renderFavorites() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-wishlist-empty]');
    var handles = read();

    if (handles.length === 0) {
      grid.innerHTML = '';
      if (empty) empty.style.display = '';
      return;
    }
    if (empty) empty.style.display = 'none';
    grid.setAttribute('aria-busy', 'true');

    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var valid = [];
      grid.innerHTML = '';
      products.forEach(function (p, idx) {
        if (!p) return; // producto ya no existe en el catalogo -> se descarta
        valid.push(handles[idx]);
        grid.appendChild(buildCell(p));
      });
      if (valid.length !== handles.length) write(valid);
      grid.removeAttribute('aria-busy');
      if (grid.children.length === 0 && empty) empty.style.display = '';
      syncCount();
    });
  }

  document.addEventListener('click', function (e) {
    var node = e.target;
    if (node && node.nodeType === 3) node = node.parentNode;
    var btn = node && node.closest ? node.closest('[data-wishlist-toggle]') : null;
    if (!btn) return;
    var handle = btn.getAttribute('data-handle');
    if (!handle) return;
    e.preventDefault();
    toggle(handle);
    syncButtons();
    syncCount();
    renderFavorites();
  });

  window.addEventListener('storage', function (e) {
    if (e.key === KEY) { syncButtons(); syncCount(); renderFavorites(); }
  });

  if ('MutationObserver' in window) {
    var timer;
    var obs = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(syncButtons, 250);
    });
    var start = function () { if (document.body) obs.observe(document.body, { childList: true, subtree: true }); };
    if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
  }

  function init() {
    syncButtons();
    syncCount();
    renderFavorites();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
